/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Copilot_Placeholder2Inputs */

const zh_landing_copilot_placeholder2 = /** @type {(inputs: Landing_Copilot_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出一份 10 道题的光合作用测验，并附答案`)
};

const en_landing_copilot_placeholder2 = /** @type {(inputs: Landing_Copilot_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make a 10-question quiz on photosynthesis with answer key`)
};

const es_landing_copilot_placeholder2 = /** @type {(inputs: Landing_Copilot_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un cuestionario de 10 preguntas sobre fotosíntesis con clave de respuestas`)
};

/**
* | output |
* | --- |
* | "Make a 10-question quiz on photosynthesis with answer key" |
*
* @param {Landing_Copilot_Placeholder2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_copilot_placeholder2 = /** @type {((inputs?: Landing_Copilot_Placeholder2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Copilot_Placeholder2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_copilot_placeholder2(inputs)
	if (locale === "en") return en_landing_copilot_placeholder2(inputs)
	return es_landing_copilot_placeholder2(inputs)
});